import { API_BASE_URL } from "../config/env";
import { apiFetch, clearCsrfToken, setCsrfToken } from "./client";
import { toApiError } from "./errors";

export interface AuthSession {
  user: { id: string; email: string; displayName: string | null };
  tenant: { id: string; name: string | null; role: string | null } | null;
  platformRoles: string[];
  csrfToken?: string;
}

export async function getAuthSession(): Promise<AuthSession | null> {
  const response = await apiFetch(`${API_BASE_URL}/auth/session`);
  if (response.status === 401) {
    clearCsrfToken();
    return null;
  }
  if (!response.ok) {
    let payload: unknown;
    try { payload = await response.json(); } catch { payload = undefined; }
    throw toApiError(response.status, payload);
  }
  const session = await response.json() as AuthSession;
  setCsrfToken(session.csrfToken);
  return session;
}

export async function logoutSession(): Promise<void> {
  const response = await apiFetch(`${API_BASE_URL}/auth/logout`, { method: "POST" });
  if (!response.ok) {
    let payload: unknown;
    try { payload = await response.json(); } catch { payload = undefined; }
    throw toApiError(response.status, payload);
  }
  clearCsrfToken();
}

